import classNames from 'classnames';
import { Button } from '@picsart/design-system/components/Button';
import { Avatar } from '@picsart/design-system/components/Avatar';
import { useTranslator } from '@picsart/rc/services/localization';

import useStyles from './styles';
import type { CardOverlaysProps } from './types';

const CardOverlays = ({
  title,
  description,
  showHoverOverlay,
  isParentHovered,
  hasLiveVideo,
  owner,
}: CardOverlaysProps) => {
  const classes = useStyles();
  const translate = useTranslator();
  return (
    <>
      {showHoverOverlay && (
        <div
          className={classNames(classes.hoverOverlay, {
            [classes.hoverOverlayVisible]: isParentHovered,
          })}
        >
          <div
            className={classNames(classes.tryNowButton, {
              [classes.tryNowButtonVisible]: isParentHovered,
            })}
          >
            <Button
              dataTestId="card-try-now"
              className={classes.tryNowAction}
              skin="primary"
              variant="filled"
              size="small"
            >
              {translate('Try Now')}
            </Button>
          </div>
        </div>
      )}
      {title && (
        <div
          className={classNames(classes.titleOverlay, {
            [classes.titleOverlayHidden]: isParentHovered,
            [classes.titleOverlayOverVideo]: hasLiveVideo,
          })}
        >
          {title}
          {owner && (
            <div className={classes.byline} data-testid="card-byline">
              <Avatar
                size={16}
                imageSrc={owner.photo}
                imageAlt={owner.name ?? owner.username}
                initials={(owner.name ?? owner.username)
                  .charAt(0)
                  .toUpperCase()}
              />
              <span className={classes.bylineName}>@{owner.username}</span>
            </div>
          )}
        </div>
      )}
      {showHoverOverlay && title && (
        <div
          className={classNames(classes.infoOverlay, {
            [classes.infoOverlayVisible]: isParentHovered,
          })}
        >
          <div className={classes.infoTitle}>{title}</div>
          {description && (
            <div className={classes.infoDescription}>{description}</div>
          )}
          {!description && (
            <div className={classes.infoHint}>
              {translate('Click to see full details')}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CardOverlays;
